import React, { useRef } from "react";

const UploadButton = ({
  caseNumber,
  caseId,
  setCaseFiles,
  caseFiles,
  setSelectedFiles,
}) => {
  const fileInput = useRef(null);
  // A function for a  button that will show dialog modal

  // A button to brwose the file system for the user to select a file to upload
  const handleFileUpload = () => {
    fileInput.current.click();
  };

  // A function to handle the file upload
  const handleFileUploadChange = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    let selectedFiles = e.target.files;
    let caseFilesRef = caseFiles.slice();
    for (let i = 0; i < selectedFiles.length; i++) {
      let file = {};
      file.fileName = selectedFiles[i].name;
      file.caseNumber = caseNumber;
      file.caseId = caseId;

      caseFilesRef.push(file);
    }
    console.log(caseFilesRef);
    setCaseFiles(caseFilesRef);
    setSelectedFiles(selectedFiles);
  };
  return (
    <>
      <button
        onClick={handleFileUpload}
        className="flex    border border-primary  border-dashed rounded justify-center   shadow-md py-6 px-2 text-center hover:bg-sidebar/10 "
      >
        <span>Upload Files</span>
      </button>
      <input
        id="myInput"
        type="file"
        ref={fileInput}
        style={{ display: "none" }}
        onChange={handleFileUploadChange}
        multiple
      />
    </>
  );
};

export default UploadButton;
